export default __webpack_public_path__ + "7652cc997f64c426866d45a68c9dd355.svg";